import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { LotWiseInfoModel } from './lot-wise-rport-model';

export class LotWiseInfoResponseModel extends GlobalResponseObject {
    data?: LotWiseInfoModel;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: LotWiseInfoModel){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}